<script lang="ts" setup>
import { useRoute } from "#app"; // Properties

// Properties
const props = defineProps({
    tabs: {
        type: Object as PropType<{ key: string; label: string }[]>,
        default: null,
    },
    initialActiveTab: {
        type: String,
        default: null,
    },
    collapsibleEnabledSize: {
        type: String,
        default: "lg",
    },
    styleOption: {
        type: String,
        default: "normal",
    },
});

// Data
const activeTab = ref("");
const route = useRoute();

// Functions
function clickTab(val: string) {
    activeTab.value = val;
    history.pushState({}, "", route.path + "#" + val);
}

if (props.tabs.length > 0) {
    activeTab.value = props.tabs[0].key;
}

onMounted(() => {
    if (props.initialActiveTab) {
        activeTab.value = props.initialActiveTab;
    } else if (window.location.hash) {
        activeTab.value = window.location.hash.substr(1);
    }
});
</script>

<template>
    <div>
        <!-- Tab view -->
        <div class="tab-content">
            <ul>
                <li
                    v-for="obj in tabs"
                    :key="obj.key"
                    :class="activeTab === obj.key ? 'active' : 'default'"
                    @click="clickTab(obj.key)"
                >
                    {{ obj.label }}
                </li>
            </ul>
            <div class="bg-abc-gray px-8 py-8">
                <div v-for="obj in tabs" v-show="activeTab === obj.key" :id="obj.key" :key="`tab-body-${obj.key}`">
                    <slot :name="obj.key" :click-tab="clickTab"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
@reference "~/assets/css/styles.css";
.tab-content ul {
    @apply ml-4 list-none overflow-auto;
}

.tab-content li {
    @apply float-left cursor-pointer border border-b-0 px-4 py-1 hover:border-2 hover:border-b-0 hover:border-gray-500;
    @apply mx-1 rounded-tl-md rounded-tr-md;
}

.tab-content .active {
    @apply bg-abc-gray border-2 border-b-0 border-gray-500;
}

.tab-content .default {
    @apply border-gray-300 bg-white;
}
</style>
